module.exports = __webpack_public_path__ + "img/dark.f42694dc.svg";